import { Cart, CartEntity } from "./cartInterfaces";

import { ReduxState } from "Store/rootReducer";
import { isDefined } from "Utils/functions";
import { useSelector } from "react-redux";

const cartSelector = (state: ReduxState): CartEntity => state.cart;

export const useCartSelector = (): CartEntity =>
  useSelector((state: ReduxState) => state.cart);

export const definedCartSelector = (state: ReduxState): Cart => {
  const cart = cartSelector(state).current;
  if (!isDefined(cart)) {
    throw new Error("Cart was unexpectedly null!");
  }
  return cart;
};
